import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
  AbstractControl, NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors
} from "@angular/forms";
import {AddressComponent} from "../../../shared/form-field/address/address.component";

@Component({
    selector: 'app-job-site-address-detail',
    templateUrl: './job-site-address-detail.component.html',
    styleUrls: ['./job-site-address-detail.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => JobSiteAddressDetailComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => JobSiteAddressDetailComponent),
            multi: true
        }
    ],
    standalone: false
})
export class JobSiteAddressDetailComponent implements OnInit {
  // @ts-ignore
  @ViewChild(AddressComponent,{static: true}) addressComponent: AddressComponent;
  @Input() isEdit: boolean = false;
  @Input() model: any = {};
  @Input() form: any = {};
  @Output() onInitForm = new EventEmitter<any>(true);
  public onModelValueChanged:any = {};
  public edit_address: any = {};
  public warehouseDetailForm: UntypedFormGroup = new UntypedFormGroup({
    main_address: new UntypedFormControl(null),
  });

  constructor() { }


  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
    this.onModelValueChanged = this.model.model;

     this.edit_address = {
      address_line_1: this?.model?.address,
      address_line_2: this?.model?.address2,
      relations: {state:this.model?.relations?.state},
      city: this?.model?.city,
      zipcode: this?.model?.zipcode
    }
    console.log('edit',this.edit_address);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    // this.setDataOnEdit();
  }
  initChildForm(value: any){
    this.warehouseDetailForm.get('main_address')?.setValue(value);
    this.onInitForm.emit(this.warehouseDetailForm);
  }
  initFormControlValues(value: any){
    if (value){
      this.warehouseDetailForm.get('main_address')?.setValue(this.addressComponent.initFormControlValues(value));
    }
    return this.warehouseDetailForm;
  }

  setDataOnEdit() {
    if(this.isEdit) {
      this.warehouseDetailForm.get('main_address')?.setValue(this.edit_address);
    }
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.warehouseDetailForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.warehouseDetailForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.warehouseDetailForm.disable() : this.warehouseDetailForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.warehouseDetailForm.valid ? null : { invalidForm: {valid: false, message: "Warehouse detail fields are invalid"}};
  }


}
